export default __webpack_public_path__ + "static/media/drinkoFarmImageOne.1b154078.png";